export const plantTaskConfig = {
    Discarding: { label: "Discard", icon: "fas fa-trash" },
    Harvesting: { label: "Harvest", icon: "fas fa-tractor" },
    Transplanting: { label: "Transplant", icon: "fas fa-share-square" },
    Seeding: { label: "Seed", icon: "fas fa-spa" },
};

export const filterOptions = Object.keys(plantTaskConfig);

